import React from "react"
import PropTypes from "prop-types"
import {
  reservationRecapContainer,
  reservationTitle,
} from "./reservation-part-7.module.scss"
import {
  ReservationSubContainer,
  ReservationTitle,
} from "../reservation-styled.js"

export const ReservationPart7 = ({ mail }) => {
  return (
    <ReservationSubContainer className={reservationRecapContainer}>
      <ReservationTitle className={reservationTitle}>
        Votre demande a bien été prise en compte !
      </ReservationTitle>
      {mail && (
        <p>
          Vous recevrez un e-mail de confirmation à l&apos;adresse <b>{mail}</b>
          . Si vous ne recevez pas de confirmation, veuillez réessayer.
        </p>
      )}
    </ReservationSubContainer>
  )
}

ReservationPart7.propTypes = {
  mail: PropTypes.string,
}
